// extracted by mini-css-extract-plugin
module.exports = {"button":"VerifyCodeForm_button__1keYt"};